import { useState } from "react";
import { ImageIcon } from "lucide-react";
import { useThemeCustomization } from "@/hooks/useThemeCustomization";

interface BrandLogoProps {
  appName?: string | null;
  /** Shows the logo inside the premium login frame. */
  framed?: boolean;
}

export const BrandLogo = ({ appName, framed = false }: BrandLogoProps = {}) => {
  const { logoUrl, brandName } = useThemeCustomization(appName);
  const [failed, setFailed] = useState(false);

  if (framed) {
    return (
      <div className="login-logo mb-6" aria-label={brandName}>
        {logoUrl && !failed ? (
          <img src={logoUrl} alt={`${brandName} Logo`} className="h-full w-full object-contain p-3"
            onError={() => setFailed(true)} />
        ) : (
          <ImageIcon className="h-10 w-10" aria-hidden />
        )}
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center mb-8">
      <div className="mb-6">
        <img src={logoUrl} alt={`${brandName} Logo`} className="h-32 w-auto mb-4 object-contain" />
      </div>
    </div>
  );
};
